var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AsyncStorage } from './storage';
import EventEmitter from 'event-emitter';
export const AUTH_CLIENT_ID = 'AuthClient__Session';
const emitter = EventEmitter();
const getSignInApi = (provider) => {
    if (provider === 'INTERNAL')
        return '/auth';
    return '/user/v2/authorize';
};
const getSignInCredentials = (credentials) => {
    if (credentials.provider === 'INTERNAL') {
        return {
            email: credentials.username,
            password: credentials.password,
        };
    }
    return credentials;
};
const signIn = (apiUrl_1, credentials_1, ...args_1) => __awaiter(void 0, [apiUrl_1, credentials_1, ...args_1], void 0, function* (apiUrl, credentials, options = {}) {
    const params = new URLSearchParams(options.params).toString();
    const url = new URL(`${apiUrl.replace(/\/$/, '')}${getSignInApi(credentials.provider)}?${params}`).toString();
    return fetch(url, {
        method: 'post',
        headers: Object.assign({ 'Captcha-Token': options.recaptchaToken, 'Content-Type': 'application/json' }, (options.headers || {})),
        body: JSON.stringify(getSignInCredentials(credentials)),
    })
        .then((response) => __awaiter(void 0, void 0, void 0, function* () {
        if (response.status >= 400)
            throw yield response.json();
        return response.json();
    }))
        .then((response) => {
        if ('error' in response) {
            throw Object.assign(Object.assign({}, response), { message: response.error });
        }
        return response;
    });
});
const signUp = (apiUrl_1, data_1, ...args_1) => __awaiter(void 0, [apiUrl_1, data_1, ...args_1], void 0, function* (apiUrl, data, options = {}) {
    const params = new URLSearchParams(options.params).toString();
    const url = new URL(`${apiUrl.replace(/\/$/, '')}/user/v2/create?${params}`, apiUrl).toString();
    return fetch(url, {
        method: 'post',
        headers: Object.assign({ 'Captcha-Token': options.recaptchaToken, 'Content-Type': 'application/json' }, (options.headers || {})),
        body: JSON.stringify(data),
    }).then((response) => __awaiter(void 0, void 0, void 0, function* () {
        if (response.status >= 400)
            throw yield response.json();
        return response.json();
    }));
});
const dispatchAuthStageChangeEvent = (event) => {
    emitter.emit('auth-state-change', Object.assign({}, event));
};
const addAuthStateChangeListener = (callback) => {
    const listener = (event) => {
        callback(event);
    };
    emitter.on('auth-state-change', listener);
    return {
        remove() {
            emitter.off('auth-state-change', listener);
        },
    };
};
export class AuthClient {
    constructor(apiUrl = '', options) {
        this.apiUrl = apiUrl;
        const storage = options.storage || new AsyncStorage(localStorage);
        storage.get(AUTH_CLIENT_ID).then((session) => {
            this.session = session;
        });
        this.stateChangeListener = this.onAuthStateChange((_a) => __awaiter(this, [_a], void 0, function* ({ action, session }) {
            if (action === 'sign-out') {
                yield storage.remove(AUTH_CLIENT_ID);
                return;
            }
            yield storage.set(AUTH_CLIENT_ID, session).then(() => {
                this.session = Object.freeze(session);
            });
        }));
    }
    signIn(credentials_1) {
        return __awaiter(this, arguments, void 0, function* (credentials, options = {}) {
            const session = yield signIn(this.apiUrl, credentials, options);
            dispatchAuthStageChangeEvent({
                action: 'sign-in',
                session,
            });
            return session;
        });
    }
    signUp(data_1) {
        return __awaiter(this, arguments, void 0, function* (data, options = {}) {
            const session = yield signUp(this.apiUrl, data, options);
            dispatchAuthStageChangeEvent({
                action: 'sign-up',
                session,
            });
            return session;
        });
    }
    // eslint-disable-next-line class-methods-use-this
    signOut() {
        dispatchAuthStageChangeEvent({
            action: 'sign-out',
            session: undefined,
        });
    }
    // eslint-disable-next-line class-methods-use-this
    onAuthStateChange(callback) {
        return addAuthStateChangeListener(callback);
    }
}
export const createClient = (apiUrl, options) => new AuthClient(apiUrl, options !== null && options !== void 0 ? options : (() => {
    throw new Error('options cannot be null when you are instantiating client');
})());
